/**
 * Wraps a given value in an array. Will return an empty array if the value is `undefined` or `null`.
 */
export const wrapInArray = (value) => {
    return value != null ? [value] : [];
};
//# sourceMappingURL=wrap-in-array.js.map